import * as React from "react";
import { Locale } from "@linkfluence/models/locale";
import Tooltip, { Placement } from "@ui-kit/tooltip";
import { tr } from "@radarly/i18n";

interface IProps {
  locale: Locale;
  children: React.ReactNode;
  isAccessible: boolean;
  isActive: boolean;
  placement?: Placement;
}

function getTooltip(locale: Locale, isAccessible: boolean, isActive: boolean) {
  if (!isAccessible) {
    return tr(locale, "MAIN_MENU.PROJECTS_PANEL_PROJECT_BLOCKED");
  } else if (!isActive) {
    return tr(locale, "MAIN_MENU.PROJECTS_PANEL_PROJECT_PAUSED");
  } else {
    return "";
  }
}

const RadarlyTooltipProject = ({
  locale,
  children,
  placement,
  isAccessible,
  isActive,
}: IProps) => {
  const tooltip = getTooltip(locale, isAccessible, isActive);
  return tooltip !== "" ? (
    <Tooltip tooltip={tooltip} placement={placement}>
      {children}
    </Tooltip>
  ) : (
    <>{children}</>
  );
};

export default RadarlyTooltipProject;
